import type { NextPage } from 'next'
import { projectStateItems } from '../../modules/project/types'

// 진행상태
export const Component: NextPage = ({ children }) => {
  const selectedItem = projectStateItems.find(item => item.value === children) || null;
  if (selectedItem) {
    return (<span className={selectedItem.className}>{selectedItem.name}</span>)
  } else {
    return (<span data-value={{children}}>invalid</span>);
  }
}

export default Component
